import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardLink,
  MDBCardTitle,
  MDBDatatable,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import AddBrand from "../../components/topviews/addBrand";
import AddSMSCampaign from "../../components/topviews/addSMSCampaign";
import SMSBrand from '../smsbrand/SMSBrand';
import SMSCampaign from '../smsbrand/SMSCampaign';
// import SmsComplianceMDB from '../smsbrand/SmsCompliance';
import { getMisc } from '../../apiclients/streamsapi_bridge';
import SmsCompliance from '../smsbrand/SmsCompliance';
import CampaignDraft from '../smsbrand/CampaignDraft';


function SMSLandingPage(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const previewRef = useRef(null);

  const [centredModal3, setCentredModal3] = useState(false);

  const toggleOpen3 = () => setCentredModal3(!centredModal3);

  const [centredModal5, setCentredModal5] = useState(false);

  const toggleOpen5 = () => setCentredModal5(!centredModal5);

  // Add ref for CampaignDraft component
  const campaignDraftRef = useRef(null);



  const handleDragOver = (event) => {
    event.preventDefault();
    document
      .getElementById("uploadFile")
      .parentNode.classList.add("draging", "dragBox");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    document
      .getElementById("uploadFile")
      .parentNode.classList.remove("draging");
    document.getElementById("uploadFile").parentNode.classList.add("dragBox");
    const file = event.dataTransfer.files[0];
    previewImage(file);
  };

  const previewImage = (file) => {
    const previewDiv = previewRef.current;

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const previewImage = document.createElement("img");
        previewImage.src = reader.result;
        previewDiv.innerHTML = "";
        previewDiv.appendChild(previewImage);
      };
      reader.readAsDataURL(file);
    } else {
      previewDiv.innerHTML = "";
    }
  };
  const [centredModal, setCentredModal] = useState(false);
  const toggleOpen = () => setCentredModal(!centredModal);

  const [centredModal4, setCentredModal4] = useState(false);

  const toggleOpen4 = () => setCentredModal4(!centredModal4);

  const navigate = useNavigate();
  function APIDetailPage() {
    navigate("/apidetails")
  };

  const [centredModal2, setCentredModal2] = useState(false);
  const toggleOpen2 = () => setCentredModal2(!centredModal2);


  const location = useLocation();
  const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
  const [basicActive, setBasicActive] = useState(actTab);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [verticalActive, setVerticalActive] = useState("tab1");
  const [brandMiscInfo, setbrandMiscInfo] = useState({});
  const [isloading, setIsloading] = useState(false);
  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };


  const showThisInfoSms = () => {
    navigate("/smscampaignregistration");
  }

  const handleCreateBrand = () => {
    // Stop polling if on drafts tab
    if (basicActive === 'tab3' && campaignDraftRef.current) {
      campaignDraftRef.current.clearPolling();
    }
    
    fetchData();
  }

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    setIsloading(true);
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["brand_cmpg_mics"] }
    );
    setIsloading(false);
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with ID not found`);
      // navigate("/");
    }
    setbrandMiscInfo(tdata.misc?.brand_cmpg_mics ?? {});
    toggleOpen4();
  }
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={270}
          content={
            <>

              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">SMS Registration</h5>
                  </div>
                  <div>

                    <MDBTabs className="mb-3 d-flex justify-content-between">
                      <div className="d-flex">
                        <MDBTabsItem>
                          <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                            Brands
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                            Campaigns
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                            Drafts
                          </MDBTabsLink>
                        </MDBTabsItem>
                      </div>


                      <MDBBtn className=" btn_adjust mb-1" onClick={(e) => { e.preventDefault(); handleCreateBrand(); }}>
                        <MDBIcon fas icon="plus" size="sm" className="me-2" /> Create Brand & Campaign
                      </MDBBtn>

                    </MDBTabs>
                    <MDBTabsContent>

                      <MDBTabsPane open={basicActive === 'tab1'}>
                        <SMSBrand
                         basicActive={basicActive === 'tab1'}
                        />

                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === 'tab2'}>
                        <SMSCampaign
                          basicActive={basicActive === 'tab2'}
                        />
                      </MDBTabsPane>

                      <MDBTabsPane open={basicActive === 'tab3'}>
                        <CampaignDraft
                          ref={campaignDraftRef}
                          basicActive={basicActive === 'tab3'}
                        />
                      </MDBTabsPane>
                    </MDBTabsContent>

                  </div>
                </div>
              </section>


              <MDBModal open={centredModal2} setOpen={setCentredModal2} tabIndex="-1"  >
                <MDBModalDialog>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Why do I need to register my Company and its Phone numbers?</MDBModalTitle>
                      <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleOpen2}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div class="smsinstructions">
                        <ul>
                          <li>In the United States, a series of laws and regulations were passed in 2019 and 2020 to make telecommunications and, more importantly, messaging over SMS more secure and trusted. To do this the Mobile Network Operators (MNO), Verizon, AT&amp;T, T-Mobile, etc., have come together to create a central place to store data on who is using their networks and for what purpose. This effort has created an organization that is known as the Campaign Registry.</li>
                          <li>The goal of the registry is to create a database of businesses so that the MNOs can verify that messages being sent to their users are coming from trusted businesses sources, and not spam or bots. This database will include identifying information for the businesses sending messages so that, if there are any issues, the MNOs and the Campaign Registry knows who to reach out to.</li>
                          <li>To create the database, the Campaign Registry has worked with internet-based telecommunication providers, known as communication service providers (CSP), to help set up protocols on how their users can then register themselves with the Campaign Registry. The CSPs then pass the info onto the registry to approve the use case. Once approved (often instant), then the company and their phone numbers are entered into the database with id numbers. These numbers are then attached to all outbound communication so that the receiving MNOs can check it on their end and let the message through</li>
                          <li>You have to register to verify your business and the messages you are sending. This is how the MNOs can verify that your phone number(s) and the messages being sent by it are legitimate. With a verified business, you can send messages across their networks with improved deliverability and at faster speeds.</li>
                        </ul>
                      </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={toggleOpen2}>
                        {t("close")}
                      </MDBBtn>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
          }
        />
        <MDBModal open={centredModal5} onClose={() => setCentredModal5(false)} tabIndex='-1'>
          <MDBModalDialog size="fullscreen">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle className="d-flex align-items-center justify-content-center">
                  {t('Brandregistration')}
                </MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={toggleOpen5}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className="fullPageModel">
                <AddBrand
                  closePopup={toggleOpen5}
                />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>


        <MDBModal open={centredModal3} onClose={() => setCentredModal3(false)} tabIndex='-1'>
          <MDBModalDialog >
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle className="d-flex align-items-center justify-content-center">
                  Terms of Use
                </MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={toggleOpen3}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className="fullPageModel">
                <div class="smsinstructions">
                  <ul>
                    <li>Last Updated: February 09, 2023</li>
                    <li>The Federal Communications Commission (FCC) has adopted 988 as a new three-digit number to be used nationwide to reach the National Suicide Prevention and Mental Health Crisis Lifeline, starting July 16, 2022. Customers must continue to dial 1-800-273-TALK to reach Lifeline until July 16, 2022.</li>
                    <li>If your area code is included in the list below, you will need to change the way you dial local calls from 7 digit dialing to 10 digit dialing:</li>
                    <li>What will be the new dialing procedure?<br /><br />
                      To complete all local calls, you will now need to dial area code + telephone number. This applies to all calls within your area code that are currently dialed with seven digits.</li>
                    <li>What will you need to do?<br /><br />
                      In addition to changing the way you dial local calls, all services, automatic dialing equipment, or other types of equipment that are programmed to complete calls to 7-digit local numbers will need to be reprogrammed to complete calls to 10-digit numbers. Some examples are life safety systems or medical monitoring devices, PBXs, fax machines, Internet dial-up numbers, fire or burglar alarm and security systems or gates, speed dialers, mobile or other wireless phone contact lists, call forwarding settings, voicemail services and other similar functions. Be sure to check your website, personal and business stationery, advertising materials, personal and business checks, contact information, your personal or pet ID tags, and other such items to ensure the area code is included.</li>
                    <li>When will the change begin?<br /><br />
                      The North American Numbering Plan Administrator (NANPA) developed, based on input from covered service providers, an implementation schedule that will allow all covered providers to meet the transition deadline in an efficient manner that best accounts for the challenges each covered provider faces.<br /><br />
                      Beginning April 24, 2021, you should begin dialing 10 digits (area code + telephone number) for all local calls. If you forget and dial just 7 digits, your call will still be completed.<br /><br />
                      The 10-digit dialing requirement for all local calls will be implemented by South Dakota telecommunications companies from October 24, 2021, through July 15, 2022. Depending on your telephone provider, you must begin to dial 10-digits to complete a local call sometime during that timeframe. Once your provider has implemented the 10-digit dialing requirement, local calls dialed with only 7-digits may not be completed, and a recording will inform you that your call cannot be completed as dialed. You must hang up and dial again using the area code and the 7-digit number. For specific information on the timeline, contact your local telephone provider.<br /><br />
                      Beginning July 16, 2022, dialing 988 will route your call to National Suicide Prevention and Mental Health Crisis Lifeline.<br /><br /></li>
                    <li>Will I or anyone I know need to change our phone number?<br /><br />
                      No. One of the reasons for changing to 10-digit dialing is to avoid the need to change people’s telephone numbers.</li>
                    <li>What other changes will I need to make?<br /><br />
                      In addition to changing your dialing patterns, all services, automatic dialing equipment, or other types of equipment that are programmed to complete local calls using only seven-digit numbers will need to be reprogrammed to complete calls to 10-digit numbers. Some examples are:<br /><br />
                      <ul >
                        <li>Private Branch Exchanges, or PBXs</li>
                        <li>life safety systems or medical monitoring devices (like LifeAlert)</li>
                        <li>fax machines</li>
                        <li>Internet dial-up numbers</li>
                        <li>fire or burglar alarm and security systems or gates</li>
                        <li>speed dialers</li>
                        <li>mobile or other phone contact lists</li>
                        <li>call forwarding settings</li>
                        <li>voicemail services and other similar functions</li>
                      </ul><br />
                      Taking the time to update the programmed call settings on your contact lists, home security systems, wearable alarms and calling networks within companies will help ensure all of these systems we rely on will continue working properly long past the required implementation deadline in October of this year.<br /><br />
                      You should also be sure to check contact information on websites, personal and business stationery, advertising materials, personal and business checks, your personal or pet ID tags, and other such items to ensure the area code is included.<br /><br />
                    </li>
                    <li>What can I expect to stay the same?<br /><br />
                      <ul >
                        <li>Your telephone number, including current area code, will not change.</li>
                        <li>The price of a call, coverage area, or other rates and services will not change due to the dialing change.</li>
                        <li>What is a local call now will remain a local call regardless of the number of digits dialed.</li>
                        <li>You will continue to dial 1+ the area code + telephone number for all long-distance calls</li>
                        <li>You will continue to dial a prefix (such as “9”) when dialing from a multi-line telephone system (i.e., in a hotel, office building, etc.) as required.</li>
                        <li>You can still dial just three digits to reach 711 (relay services) and 911 (emergency services).</li>
                        <li>Any 211, 311, 411, 511, 611, or 811 services available in your community can still be reached by dialing their three-digit codes.</li>
                        <li>The National Suicide Prevention Lifeline can still be reached by dialing 1-800-273-8255 (TALK) even after the 988 code is in effect.</li>
                      </ul><br />
                    </li>
                    <li>Will you be able to dial 988 without a prefix from a multi-line telephone system?<br /><br />
                      No, you still will need to dial a prefix first when dialing 988 from a multi-line telephone system, where a prefix is required (for example, dialing 9 first from a hotel or office building multi-line telephone system).</li>
                    <li>Where can I go for additional information?<br /><br />
                      If you have any questions regarding information provided in this notice, please contact your local service provider for more information. You can also visit the FCC website at <Link href="">https://www.fcc.gov/suicideprevention-hotline.</Link></li>
                  </ul>
                </div>
              </MDBModalBody>

              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={toggleOpen2}>
                  {t("close")}
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <MDBModal open={centredModal4} onClose={() => setCentredModal4(false)} tabIndex='-1'>
          <MDBModalDialog size="fullscreen" centered>
            <MDBModalContent>
              {/* <MDBModalHeader>
                                    <MDBModalTitle className="d-flex align-items-center justify-content-center">
                                        SMS Campaign Registration
                                    </MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={toggleOpen4}></MDBBtn>
                                </MDBModalHeader> */}
              <MDBModalBody className="xl p-0">
                {/* <AddSMSCampaign
                                        isActive={basicActive}
                                        closePopup={toggleOpen4}
                                        draftDetails={draftDetails}
                                    /> */}
                <SmsCompliance brandMiscInfo={brandMiscInfo} basicActive = {basicActive} closePopup={toggleOpen4} />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}



      </>
    </React.Fragment>
  );
}

export default SMSLandingPage;